import api from 'services/api'
import { getDefaultAddressPostCode } from 'services/api/parser/profile'
import {
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
} from '../../constants'

const getProfileSuccess = response => ({
  type: GET_PROFILE_SUCCESS,
  response,
})

const getProfileFailure = response => ({
  type: GET_PROFILE_FAILURE,
  response,
})

const getProfile = (param = { full: 'n' }) => dispatch =>
  api.request('getProfile', {}, param).then((response) => {
    if (response.blockScript) {
      const { redirectUrl } = response
      window.location.assign(redirectUrl)
    } else if (response.status !== 'ERROR') {
      const { profileAttributes = [], addresses = [] } = response
      const isBabyClubMember = !!profileAttributes.length
        && profileAttributes.some(ele => ele.attributeName === 'btc')
      dispatch(getProfileSuccess({
        ...response,
        isBabyClubMember,
        postCode: getDefaultAddressPostCode(addresses),
      }))
    }
  }).catch((error) => {
    dispatch(getProfileFailure(error))
  })

export default getProfile



// WEBPACK FOOTER //
// ./services/app-state/profile/actions/getProfile/index.js